if (!customElements.get('store-info-map')) {
  customElements.define(
    'store-info-map',
    class StoreInfoMap extends HTMLElement {
      constructor() {
        super();

        this.map = null;
        this.marker = null;
      }

      connectedCallback() {
        this.initialize();
      }

      disconnectedCallback() {
        if (this.marker) {
          if (typeof this.marker.setMap === 'function') {
            this.marker.setMap(null);
          } else {
            this.marker.map = null;
          }

          this.marker = null;
        }
        this.map = null;
      }

      getConfig() {
        const configElement = this.querySelector("script[type='application/json']");
        if (!configElement) return null;

        try {
          return JSON.parse(configElement.textContent);
        } catch (error) {
          console.error(error);
          return null;
        }
      }

      getPositiveNumber(value, fallback) {
        const number = parseInt(value, 10);

        return Number.isNaN(number) || number <= 0 ? fallback : number;
      }

      createMarkerIcon(markerUrl, markerTitle, markerWidth, markerHeight) {
        if (!markerUrl) return null;

        const markerImg = document.createElement('img');
        markerImg.src = markerUrl;
        markerImg.width = markerWidth;
        markerImg.height = markerHeight;
        markerImg.alt = markerTitle || '';
        return markerImg;
      }

      getGrayScaleStyles() {
        return [
          {
            elementType: 'geometry',
            stylers: [{ color: '#f1f1f1' }]
          },
          {
            elementType: 'labels.icon',
            stylers: [{ visibility: 'off' }]
          },
          {
            elementType: 'labels.text.fill',
            stylers: [{ color: '#8a8a8a' }]
          },
          {
            elementType: 'labels.text.stroke',
            stylers: [{ color: '#f1f1f1' }]
          },
          {
            featureType: 'administrative.neighborhood',
            elementType: 'labels.text.fill',
            stylers: [{ color: '#6f6f6f' }]
          },
          {
            featureType: 'poi',
            stylers: [{ visibility: 'off' }]
          },
          {
            featureType: 'road',
            elementType: 'geometry',
            stylers: [{ color: '#ffffff' }]
          },
          {
            featureType: 'road',
            elementType: 'labels.text.fill',
            stylers: [{ color: '#777777' }]
          },
          {
            featureType: 'road.arterial',
            elementType: 'geometry',
            stylers: [{ color: '#d7d7d7' }]
          },
          {
            featureType: 'road.highway',
            elementType: 'geometry',
            stylers: [{ color: '#cfcfcf' }]
          },
          {
            featureType: 'transit',
            stylers: [{ visibility: 'off' }]
          },
          {
            featureType: 'water',
            elementType: 'geometry',
            stylers: [{ color: '#e3e3e3' }]
          },
          {
            featureType: 'water',
            elementType: 'labels.text.fill',
            stylers: [{ color: '#9a9a9a' }]
          }
        ];
      }

      async initialize() {
        const config = this.getConfig();
        const mapCanvas = this.querySelector('[data-map-canvas]');

        if (!config || !mapCanvas || !window.google?.maps?.importLibrary) return;

        const latitude = parseFloat(config.latitude);
        const longitude = parseFloat(config.longitude);
        const zoom = parseInt(config.zoom, 10);
        const markerWidth = this.getPositiveNumber(config.markerWidth, 48);
        const markerHeight = this.getPositiveNumber(config.markerHeight, 48);

        if (Number.isNaN(latitude) || Number.isNaN(longitude)) return;

        const { Map } = await google.maps.importLibrary('maps');
        const center = {
          lat: latitude,
          lng: longitude
        };
        const styles = config.grayScale ? this.getGrayScaleStyles() : [];
        const mapOptions = {
          center,
          zoom: Number.isNaN(zoom) ? 15 : zoom,
          clickableIcons: false,
          disableDefaultUI: true,
          gestureHandling: 'cooperative',
          keyboardShortcuts: false,
          mapTypeId: 'roadmap',
          styles
        };

        if (config.mapId && !config.grayScale) {
          mapOptions.mapId = config.mapId;
        }

        this.map = new Map(mapCanvas, mapOptions);

        const markerOptions = {
          map: this.map,
          position: center,
          title: config.markerTitle || ''
        };

        if (config.grayScale) {
          if (config.marker) {
            markerOptions.icon = {
              url: config.marker,
              scaledSize: new google.maps.Size(markerWidth, markerHeight),
              anchor: new google.maps.Point(markerWidth / 2, markerHeight)
            };
          }

          this.marker = new google.maps.Marker(markerOptions);
        } else {
          const { AdvancedMarkerElement } = await google.maps.importLibrary('marker');
          const markerIcon = this.createMarkerIcon(
            config.marker,
            config.markerTitle,
            markerWidth,
            markerHeight
          );

          if (markerIcon) {
            markerOptions.content = markerIcon;
          }

          this.marker = new AdvancedMarkerElement(markerOptions);
        }

        this.classList.add('p80-store-info__map--loaded');
      }
    }
  );
}
